import { decodeString } from '@cat-ecom/common/utils/stringUtils';
import { UOM } from 'constants/common';
import { Facet } from 'services/internalSearch/types';
import { Facet as plpFacet } from 'services/internal-product-list/types';
import { SPECIALS_FACETS } from './constants';
import { itemsTypes } from './types';

export const getFacetItems = (
  items: itemsTypes[],
  selectedFacets: string | string[]
) =>
  items?.map(({ facet, label, values, count }) => ({
    id: facet ?? label,
    name: label,
    checked: selectedFacets?.includes(decodeString(facet)),
    ...(count && { count }),
    ...(!!values && {
      values: values.map(({ label, facet, count }) => ({
        id: facet,
        name: label,
        checked: selectedFacets?.includes(decodeString(facet)),
        count
      }))
    })
  }));

export const filterFacets = (facets: Facet[] | plpFacet[], uom: string) =>
  facets.filter(
    (facet) =>
      facet.uom === uom ||
      facet.uom === UOM.c62 ||
      facet.facetId?.toUpperCase() === SPECIALS_FACETS
  );

export const getFacetsToDelete = (
  facets: Facet[] | plpFacet[],
  uomValue: string,
  selectedFacets: string | string[]
) =>
  facets
    .reduce(
      (acc, { uom, value }) => [
        ...acc,
        ...value.map(({ facet }) => ({
          uom,
          facet
        }))
      ],
      []
    )
    .filter(
      (facet) =>
        selectedFacets?.includes(decodeString(facet.facet)) &&
        facet.uom === uomValue
    );

export const getUpdatedFacets = (
  selectedFacets: string[],
  facetsToDelete: { uom: string; facet: string }[]
): string[] => {
  const updatedFacet = selectedFacets.filter(
    (val) =>
      !facetsToDelete
        .reduce((acc, { facet }) => [...acc, decodeString(facet)], [])
        .includes(val)
  );

  return updatedFacet;
};
